// leasing-preapproval-form.js (Final Corrected Version with All Fixes)
(function () {
  // =========================
  // Config
  // =========================
  const VALIDATION_ENABLED = true; // hard-gate steps + submit
  const CUR_YEAR = new Date().getFullYear();

  // =========================
  // Progress ring
  // =========================
  const meter = document.querySelector('.progress-ring__meter');
  const txt = document.querySelector('.progress-circle__percentage');
  const CIRC = 408.4;
  function setProgress(pct) {
    if (!meter) return;
    const clamped = Math.max(0, Math.min(100, pct));
    meter.style.strokeDasharray = CIRC;
    meter.style.strokeDashoffset = CIRC - (CIRC * clamped / 100);
    if (txt) {
      txt.innerHTML =
        '<span class="progress-circle__value">' +
        Math.round(clamped) +
        '</span><span class="progress-circle__unit">%</span>';
    }
  }
  // =========================
  // Capture SKU/Product from URL
  // =========================
  function getUrlParams() {
    const p = new URLSearchParams(window.location.search);
    return {
      sku: (p.get('sku') || '').trim(),
      product: (p.get('product') || '').trim(),
      variant: (p.get('variant') || '').trim(),
    };
  }

  const urlCtx = getUrlParams();

  // If you created hidden inputs on the form page, populate them here:
  function populateHiddenFromUrl() {
    const skuEl = formEl?.querySelector('input[name="contact[sku]"], input[name="sku"]');
    const productEl = formEl?.querySelector('input[name="contact[product_title]"], input[name="product_title"]');

    if (skuEl && urlCtx.sku) skuEl.value = urlCtx.sku;
    if (productEl && urlCtx.product) productEl.value = urlCtx.product;
  }

  function wireUpDatepicker(element) {
    // Ensure jQuery and the datepicker plugin are available
    if (!element || typeof $ === 'undefined' || !$.fn.datepicker) {
      return;
    }

    const $el = $(element);

    // Clean slate
    $el.datepicker('destroy');

    // Attach the double-click listener
    $el.on('dblclick', function () {
      const currentValue = $(this).val();
      let newStartView = 'decades'; // Default: start with years
      let defaultDate = new Date(); // Default to today

      // Logic: Determine where to jump based on what is typed
      const yearMatch = currentValue.match(/^(\d{4})/);
      const monthMatch = currentValue.match(/^\d{4}-(\d{2})/);

      if (monthMatch) {
        // If "2012-05" is typed -> Jump to Days view of May 2012
        newStartView = 'days';
        defaultDate = new Date(parseInt(yearMatch[1]), parseInt(monthMatch[1]) - 1, 1);
      } else if (yearMatch) {
        // If "2012" is typed -> Jump to Months view of 2012
        newStartView = 'months';
        defaultDate = new Date(parseInt(yearMatch[1]), 0, 1); // Jan 1st of that year
      }

      // Prevent jumping to future dates
      if (defaultDate > new Date()) {
        defaultDate = new Date();
      }

      // === THE TRICK ===
      // 1. Temporarily remove the value so the library listens to 'defaultViewDate'
      // instead of trying to parse the incomplete text "2012" and failing.
      $(this).val('');

      // 2. Initialize with our custom settings
      $(this).datepicker('destroy').datepicker({
        format: "yyyy-mm-dd",
        autoclose: true,
        todayHighlight: true,
        startView: newStartView,
        defaultViewDate: defaultDate, // This forces the year/month view
        endDate: "0d",
        forceParse: false // Important: Don't auto-format the text when we put it back
      });

      // 3. Put the user's text back immediately
      $(this).val(currentValue);

      // 4. Show the calendar
      $(this).datepicker('show');

      // Remove default focus behavior so single click doesn't reopen it
      $(this).off('focus');
    });
  }
  function isValidDate(dateString) {
    // 1. Regex check for YYYY-MM-DD format
    if (!/^\d{4}-\d{2}-\d{2}$/.test(dateString)) return false;

    // 2. Parse parts to check calendar logic
    const parts = dateString.split('-');
    const year = parseInt(parts[0], 10);
    const month = parseInt(parts[1], 10);
    const day = parseInt(parts[2], 10);

    // 3. Basic range check (Year 1900-2100, Month 1-12)
    if (year < 1900 || year > 2100 || month === 0 || month > 12) return false;

    // 4. Strict Day Check using JS Date object
    // (JavaScript automatically rolls over dates, e.g. Feb 30 -> Mar 2)
    // We check if the Input matches the Output to detect invalid days.
    const testDate = new Date(year, month - 1, day);
    return (
      testDate.getFullYear() === year &&
      testDate.getMonth() === month - 1 &&
      testDate.getDate() === day
    );
  }
  function wireUpDateMask(element) {
    if (!element) return;

    element.addEventListener('input', (e) => {
      // 1. Allow only numbers and dashes
      let value = e.target.value.replace(/[^0-9]/g, '');

      // 2. Auto-insert dashes
      if (value.length > 4) {
        value = value.slice(0, 4) + '-' + value.slice(4);
      }
      if (value.length > 7) {
        value = value.slice(0, 7) + '-' + value.slice(7, 9);
      }

      // 3. Hard limit length to 10 chars (YYYY-MM-DD)
      if (value.length > 10) {
        value = value.slice(0, 10);
      }

      e.target.value = value;
    });

    element.addEventListener('blur', (e) => {
      const value = e.target.value;

      if (!value.length) {
        // Empty: clear any existing error for this field
        clearErrorFor(e.target);
        return;
      }

      if (!isValidDate(value)) {
        showError(e.target, 'Invalid Date (YYYY-MM-DD)');
      } else {
        // Value is now valid – remove the tooltip immediately
        clearErrorFor(e.target);
      }
    });
  }

  // =========================
  // DOM refs
  // =========================
  const formEl = document.getElementById('LeasingForm');
  const stepsNav = document.getElementById('form-steps');

  const step1 = document.getElementById('step-1');
  const step2 = document.getElementById('step-2');

  const goToStep2 = document.getElementById('go-to-step-2');
  const backToStep1 = document.getElementById('back-to-step-1');
  const submitBtn = document.getElementById('submit-form');

  // Radios default unselected (pre-approval wants clean start)
  document.querySelectorAll('input[type="radio"]').forEach(r => { r.checked = false; });

  // =========================
  // Utility: sticky offsets & scrolling
  // =========================
  function measureStickyStack() {
    const candidates = [
      document.getElementById('shopify-section-header'),
      document.querySelector('.shopify-section-header'),
      document.querySelector('.announcement-bar-holder'),
      document.querySelector('header'),
    ];
    let maxBottom = 0;
    for (const el of candidates) {
      if (!el) continue;
      const r = el.getBoundingClientRect();
      if (r.top <= 2) maxBottom = Math.max(maxBottom, r.bottom);
    }
    return Math.ceil(maxBottom + 12);
  }
  function syncScrollPaddingTop() {
    const off = measureStickyStack();
    document.documentElement.style.setProperty('--sticky-offset', off + 'px');
  }
  function setTitleScrollMargin(sectionEl) {
    const title = sectionEl?.querySelector('.form-content__title');
    if (!title) return;
    title.style.scrollMarginTop = measureStickyStack() + 'px';
  }
  function getScrollContainer(el) {
    let node = el?.parentElement || null;
    while (node && node !== document.body) {
      const style = getComputedStyle(node);
      const canScrollY = /(auto|scroll|overlay)/.test(style.overflowY) && node.scrollHeight > node.clientHeight;
      if (canScrollY) return node;
      node = node.parentElement;
    }
    return window;
  }
  function getScrollTop(scroller) {
    return scroller === window
      ? window.pageYOffset || document.documentElement.scrollTop || 0
      : scroller.scrollTop;
  }
  function setScrollTop(scroller, value) {
    if (scroller === window) window.scrollTo(0, value);
    else scroller.scrollTop = value;
  }
  function easeInOutCubic(t) {
    return t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2;
  }
  function animateScrollTo(scroller, to, { duration = 800 } = {}) {
    const prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (prefersReduced) { setScrollTop(scroller, to); return Promise.resolve(); }
    const start = getScrollTop(scroller);
    const change = to - start;
    if (Math.abs(change) < 1) return Promise.resolve();
    const px = Math.abs(change);
    duration = Math.min(1100, Math.max(550, (px / 1200) * 900));
    return new Promise(resolve => {
      const startTime = performance.now();
      function step(now) {
        const t = Math.min(1, (now - startTime) / duration);
        const eased = easeInOutCubic(t);
        setScrollTop(scroller, start + change * eased);
        if (t < 1) requestAnimationFrame(step); else resolve();
      }
      requestAnimationFrame(step);
    });
  }
  function scrollTitleIntoView(sectionEl) {
    const title = sectionEl?.querySelector('.form-content__title');
    if (!title) return;
    const scroller = getScrollContainer(title);
    const offset = measureStickyStack();
    const titleRect = title.getBoundingClientRect();
    const baseTop = scroller === window
      ? titleRect.top + getScrollTop(window)
      : titleRect.top + scroller.scrollTop - (scroller.getBoundingClientRect ? scroller.getBoundingClientRect().top : 0);
    const desiredY = baseTop - offset;
    animateScrollTo(scroller, desiredY).then(() => {
      const containerTop = scroller === window ? 0 : scroller.getBoundingClientRect().top;
      const delta = title.getBoundingClientRect().top - (offset + containerTop);
      if (Math.abs(delta) > 1) setScrollTop(scroller, getScrollTop(scroller) + delta);
    });
  }
  function scrollToFormTopMobile() {
    if (!window.matchMedia('(max-width: 600px)').matches) return false;
    const formTopElement = document.querySelector('.leasing-form-outer-wrapper');
    if (!formTopElement) return false;
    const scroller = getScrollContainer(formTopElement);
    const offset = measureStickyStack();
    const rect = formTopElement.getBoundingClientRect();
    const scrollTop = getScrollTop(scroller);
    const baseTop = scroller === window
      ? rect.top + scrollTop
      : rect.top + scrollTop - scroller.getBoundingClientRect().top;
    const targetY = baseTop - offset;
    animateScrollTo(scroller, targetY);
    return true;
  }
  function scrollAfterReveal(sectionEl) {
    requestAnimationFrame(() => {
      if (scrollToFormTopMobile()) return;
      scrollTitleIntoView(sectionEl);
    });
  }

  // =========================
  // Step nav
  // =========================
  function setActiveStep(n) {
    stepsNav?.querySelectorAll('.step').forEach(li => {
      li.classList.toggle('step--active', li.getAttribute('data-step') === String(n));
    });
  }
  function showStep(n) {
    [step1, step2].forEach((s, i) => {
      if (!s) return;
      if (i === n - 1) s.classList.remove('is-hidden');
      else s.classList.add('is-hidden');
    });
    setActiveStep(n);
  }

  // =========================
  // Tooltip error CSS (no layout shift)
  // =========================
  (function injectTooltipCSS() {
    const css = `
      .field-host{ position:relative; }
      .field-error{
        position:absolute; left:0; top:100%; transform:translateY(6px);
        z-index:10; color:#b42318; background:#fff; border:1px solid #f3b4b1;
        border-radius:4px; padding:2px 6px; font-size:.85rem; line-height:1.2;
        white-space:nowrap; pointer-events:none; box-shadow:0 1px 2px rgba(0,0,0,.06);
      }
      .field-error::after{
        content:""; position:absolute; left:10px; top:-6px;
        border-left:6px solid transparent; border-right:6px solid transparent;
        border-bottom:6px solid #f3b4b1;
      }
      .field-error::before{
        content:""; position:absolute; left:10px; top:-5px;
        border-left:6px solid transparent; border-right:6px solid transparent;
        border-bottom:6px solid #fff;
      }
      .no-spinner::-webkit-outer-spin-button,.no-spinner::-webkit-inner-spin-button{-webkit-appearance:none;margin:0}
      .no-spinner{-moz-appearance:textfield}

      /* ===== FINAL DESKTOP ALIGNMENT FIX ===== */
      @media (min-width: 769px) {
        /*
         * Use the :has() selector to target ONLY the form groups containing
         * the specific side-by-side inputs on desktop.
         * This pushes their error tooltips to align with the input column.
        */
        .form-group:has(#Shareholders-0-HowLong) > .field-error,
        .form-group:has(#Shareholders-0-HomeValue) > .field-error,
        .form-group:has(#Shareholders-0-MortgageBalance) > .field-error {
          left: 18%; /* Adjust this % if your label/input split is different */
        }
      }
      /* ===== END FINAL FIX ===== */
    `;
    const s = document.createElement('style');
    s.type = 'text/css';
    s.appendChild(document.createTextNode(css));
    document.head.appendChild(s);
  })();

  // =========================
  // Error helpers
  // =========================
  function wrapAllFieldsForTooltips() {
    const form = formEl;
    if (!form) return;
    const selector = [
      'input:not([type="hidden"]):not([type="button"]):not([type="submit"])',
      'textarea',
      'select'
    ].join(',');
    form.querySelectorAll(selector).forEach((el) => {
      if (el.closest('.field-host')) return;
      const prefer = el.closest('.form-group');
      if (prefer) { prefer.classList.add('field-host'); return; }
      const rq = el.closest('.radio-question') || el.closest('.radio-options');
      if (rq) { rq.classList.add('field-host'); return; }
      const wrap = document.createElement('div');
      wrap.className = 'field-host';
      el.replaceWith(wrap);
      wrap.appendChild(el);
    });
    form.querySelectorAll('.radio-question, .radio-options').forEach(g => g.classList.add('field-host'));
  }
  function clearErrors(scope) {
    (scope || document).querySelectorAll('.field-error').forEach(n => n.remove());
    (scope || document).querySelectorAll('[aria-invalid="true"]').forEach(n => n.setAttribute('aria-invalid', 'false'));
  }
  function showError(inputEl, msg) {
    if (!inputEl) return;
    inputEl.setAttribute('aria-invalid', 'true');
    const host =
      inputEl.closest('.field-host') ||
      inputEl.closest('.form-group') ||
      inputEl.closest('.radio-question') ||
      inputEl.closest('.radio-options') ||
      inputEl.parentElement;
    if (!host) return;
    const existing = host.querySelector(':scope > .field-error');
    if (existing) { existing.textContent = msg; return; }
    const hint = document.createElement('div');
    hint.className = 'field-error';
    hint.setAttribute('role', 'status');
    hint.setAttribute('aria-live', 'polite');
    hint.textContent = msg;
    host.appendChild(hint);
  }
  function clearErrorFor(inputEl) {
    if (!inputEl) return;

    inputEl.setAttribute('aria-invalid', 'false');

    const host =
      inputEl.closest('.field-host') ||
      inputEl.closest('.nw-field') ||
      inputEl.closest('.form-group') ||
      inputEl.closest('.radio-question') ||
      inputEl.closest('.radio-options') ||
      inputEl.parentElement;

    if (!host) return;

    const existing = host.querySelector(':scope > .field-error');
    if (existing) existing.remove();
  }
  function focusAndScrollTo(el) {
    try { el.focus({ preventScroll: true }); } catch { }
    const scroller = getScrollContainer(el);
    const offset = measureStickyStack();
    const rect = el.getBoundingClientRect();
    const baseTop = (scroller === window)
      ? rect.top + getScrollTop(window)
      : rect.top + scroller.scrollTop - scroller.getBoundingClientRect().top;
    animateScrollTo(scroller, baseTop - Math.max(0, offset) - 12);
  }

  // =========================
  // Currency inputs (Home Value + Mortgage Balance)
  // =========================
  function _fmtCurrencyTyping(raw) {
    var v = (raw || '').replace(/[^0-9.]/g, '');
    var dot = v.indexOf('.');
    var int = v, dec = '';
    if (dot !== -1) {
      int = v.slice(0, dot);
      dec = v.slice(dot + 1).replace(/\./g, '').slice(0, 2);
    }
    int = int.replace(/^0+(?=\d)/, '');
    var intWithCommas = int ? int.replace(/\B(?=(\d{3})+(?!\d))/g, ',') : '0';
    return '$' + intWithCommas + (dot !== -1 ? (dec.length ? '.' + dec : '.') : '');
  }
  function _fmtCurrencyBlur(raw) {
    var v = (raw || '').replace(/[^0-9.]/g, '');
    if (!v) return '';
    var dot = v.indexOf('.');
    var int = v, dec = '';
    if (dot !== -1) {
      int = v.slice(0, dot);
      dec = v.slice(dot + 1).replace(/\./g, '').slice(0, 2);
    }
    int = int.replace(/^0+(?=\d)/, '');
    var intWithCommas = (int || '0').replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    var dec2 = (dec + '00').slice(0, 2);
    return '$' + intWithCommas + '.' + dec2;
  }
  function wireCurrencyInputById(id) {
    var el = document.getElementById(id);
    if (!el) return;
    el.setAttribute('inputmode', 'decimal');
    el.setAttribute('step', '0.01');
    el.classList.add('no-spinner');
    el.addEventListener('input', function () {
      var wasFocused = (document.activeElement === el);
      el.value = _fmtCurrencyTyping(el.value);
      if (wasFocused) {
        try { el.selectionStart = el.selectionEnd = el.value.length; } catch (e) { }
      }
      computeProgress();
    });
    el.addEventListener('blur', function () {
      el.value = _fmtCurrencyBlur(el.value);
    });
  }

  // =========================
  // Digits-only helper
  // =========================
  function wireDigitsOnlyById(id, { maxDigits = null } = {}) {
    const el = document.getElementById(id);
    if (!el) return;
    el.setAttribute('type', 'text');
    el.setAttribute('inputmode', 'numeric');
    el.setAttribute('pattern', '\\d*');
    el.classList.add('no-spinner');
    el.addEventListener('input', () => {
      let v = (el.value || '').replace(/\D/g, '');
      if (maxDigits) v = v.slice(0, maxDigits);
      el.value = v;
      computeProgress();
    });
  }

  // =========================
  // Phone formatting (10 digits)
  // =========================
  const onlyDigits = (v) => (v || '').replace(/\D/g, '');
  function fmtPhone(digits) {
    const d = onlyDigits(digits).slice(0, 10);
    if (d.length <= 3) return d;
    if (d.length <= 6) return `(${d.slice(0, 3)}) ${d.slice(3)}`;
    return `(${d.slice(0, 3)}) ${d.slice(3, 6)}-${d.slice(6)}`;
  }
  function wirePhoneInput(el) {
    if (!el) return;
    el.setAttribute('maxlength', '14');
    el.addEventListener('input', () => {
      const d = onlyDigits(el.value);
      el.value = fmtPhone(d);
      if (d.length === 10) el.setCustomValidity('');
      computeProgress();
    });
    el.addEventListener('blur', () => {
      const d = onlyDigits(el.value);
      if (d.length > 0 && d.length !== 10) {
        el.setCustomValidity('Please enter a 10-digit phone number.');
        el.reportValidity?.();
      } else {
        el.setCustomValidity('');
      }
    });
  }
  function atLeastOnePhoneOk(ids) {
    return ids.some(id => onlyDigits(document.getElementById(id)?.value || '').length === 10);
  }

  // =========================
  // Required checkbox helpers
  // =========================
  function requireConsent() {
    const box = document.getElementById('LeasingForm-consent') || formEl?.querySelector('input[name="consent"]');
    if (!box) return true;
    if (!box.checked) {
      showError(box, 'Please check this box to proceed.');
      focusAndScrollTo(box);
      return false;
    }
    return true;
  }

  // =========================
  // Dynamic Field Visibility
  // =========================
  const shareholderHomeStatusRadios = formEl?.querySelectorAll('input[name="shareholders[0][home_status]"]');
  const homeValInput = document.getElementById('Shareholders-0-HomeValue');
  const mortBalInput = document.getElementById('Shareholders-0-MortgageBalance');
  const homeValGroup = homeValInput ? homeValInput.closest('.form-group') : null;
  const mortBalGroup = mortBalInput ? mortBalInput.closest('.form-group') : null;

  function toggleShareholderHomeFields() {
    if (!shareholderHomeStatusRadios || !homeValGroup || !mortBalGroup) { computeProgress(); return; }
    const isLessee = !!formEl.querySelector('input[name="shareholders[0][home_status]"][value="Lessee"]:checked');
    homeValGroup.classList.toggle('is-hidden', isLessee);
    mortBalGroup.classList.toggle('is-hidden', isLessee);
    if (isLessee) {
      const hv = homeValGroup.querySelector('input');
      const mb = mortBalGroup.querySelector('input');
      if (hv) hv.value = '';
      if (mb) mb.value = '';
    }
    wireCurrencyInputById('Shareholders-0-HomeValue');
    wireCurrencyInputById('Shareholders-0-MortgageBalance');
    computeProgress();
  }

  const companyBankruptcyRadios = formEl?.querySelectorAll('input[name="commercial_bankruptcy"]');
  const companyDoRInput = document.getElementById('Company-DateOfRelease');
  function toggleCompanyDoR() {
    if (!companyDoRInput || !companyBankruptcyRadios) return;
    const yes = !!formEl.querySelector('input[name="commercial_bankruptcy"][value="Yes"]:checked');
    const container =
      companyDoRInput.closest('.form-group') ||
      companyDoRInput.closest('.field-host') ||
      companyDoRInput.parentElement;
    if (container) {
      container.classList.toggle('is-hidden', !yes);
      if (!yes) companyDoRInput.value = '';
    }
    computeProgress();
  }

  const shBankruptcyRadios = formEl?.querySelectorAll('input[name="shareholders[0][commercial_bankruptcy]"]');
  const shDoRInput = document.getElementById('Shareholders-0-DateOfRelease');
  function toggleShareholderDoR() {
    if (!shDoRInput || !shBankruptcyRadios) { computeProgress(); return; }
    const yes = !!formEl.querySelector('input[name="shareholders[0][commercial_bankruptcy]"][value="Yes"]:checked');
    const container =
      shDoRInput.closest('.form-group') ||
      shDoRInput.closest('.field-host') ||
      shDoRInput.parentElement;
    if (container) {
      container.classList.toggle('is-hidden', !yes);
      if (!yes) shDoRInput.value = '';
    }
    computeProgress();
  }

  // =========================
  // Validation (per step)
  // =========================
  formEl?.setAttribute('novalidate', 'novalidate');

  function valNonEmpty(inputEl, msg) {
    if (!inputEl) return true;
    if (String(inputEl.value).trim() === '') {
      showError(inputEl, msg);
      focusAndScrollTo(inputEl);
      return false;
    }
    return true;
  }
  function valRadioChecked(sectionEl, name, msg) {
    const chosen = sectionEl?.querySelector(`input[name="${name}"]:checked`);
    if (!chosen) {
      const first = sectionEl?.querySelector(`input[name="${name}"]`);
      showError(first, msg);
      focusAndScrollTo(first);
      return false;
    }
    return true;
  }
  function phonesValidSoft() {
    const ids = ['LeasingForm-business-phone', 'LeasingForm-mobile-number', 'Shareholders-0-Phone', 'Shareholders-0-Mobile'];
    for (const id of ids) {
      const el = document.getElementById(id);
      if (!el) continue;
      const d = onlyDigits(el.value);
      if (d.length > 0 && d.length !== 10) {
        showError(el, 'Please enter a 10-digit phone number or leave blank.');
        focusAndScrollTo(el);
        return false;
      }
    }
    return true;
  }
  function ensureEmailValidOrFocus() {
    const email = document.getElementById('LeasingForm-email');
    if (!email) return true;
    if (!email.value || !email.checkValidity()) {
      showError(email, 'Please enter a valid email.');
      focusAndScrollTo(email);
      return false;
    }
    return true;
  }

  function validateStep(sectionEl) {
    if (!VALIDATION_ENABLED) return true;
    clearErrors(sectionEl);
    const step = Number(sectionEl?.getAttribute('data-step') || 0);

    // STEP 1 rules
    if (step === 1) {
      const legal = sectionEl.querySelector('input[name="legal_name_of_business"]');
      const operating = sectionEl.querySelector('input[name="operating_name"]');
      const activity = sectionEl.querySelector('input[name="activity_area"]');
      const addr = sectionEl.querySelector('input[name="address"]');
      const phone = sectionEl.querySelector('#LeasingForm-business-phone');
      const mobile = sectionEl.querySelector('#LeasingForm-mobile-number');
      const email = sectionEl.querySelector('input[name="contact[email]"]');
      const years = sectionEl.querySelector('input[name="years_in_business"]');

      if (!valNonEmpty(legal, 'Please enter the legal business name.')) return false;
      if (!valNonEmpty(operating, 'Please enter the operating name.')) return false;
      if (!valNonEmpty(activity, 'Please enter the activity area.')) return false;
      if (!valNonEmpty(addr, 'Please enter the company address.')) return false;

      const businessDigits = onlyDigits(phone?.value || '');
      const mobileDigits = onlyDigits(mobile?.value || '');
      if (!businessDigits && !mobileDigits) {
        showError(phone || mobile, 'Please provide at least one phone number.');
        focusAndScrollTo(phone || mobile);
        return false;
      }

      if (!valNonEmpty(email, 'Please enter your email.')) return false;
      if (!email.checkValidity()) { showError(email, 'Please enter a valid email.'); focusAndScrollTo(email); return false; }

      if (!valNonEmpty(years, 'Please enter years in business.')) return false;

      if (!valRadioChecked(sectionEl, 'commercial_bankruptcy', 'Please answer about commercial bankruptcy.')) return false;

      if (companyDoRInput) {
        const companyYes = !!formEl.querySelector('input[name="commercial_bankruptcy"][value="Yes"]:checked');
        if (companyYes && !valNonEmpty(companyDoRInput, 'Please enter the Date of Release.')) return false;
      }

      if (!valRadioChecked(sectionEl, 'legal_actions', 'Please answer about legal actions.')) return false;

      return true;
    }

    // STEP 2 rules
    if (step === 2) {
      const wrap = sectionEl.querySelector('.shareholder');
      if (!wrap) return true;

      const fields = Array.from(wrap.querySelectorAll('input'));
      const anyFilled = fields.some(i => String(i.value).trim().length > 0);
      if (!anyFilled) return true;

      const name = wrap.querySelector('input[name="shareholders[0][contact_name]"]');
      const addr = wrap.querySelector('input[name="shareholders[0][address]"]');
      const tel = wrap.querySelector('#Shareholders-0-Phone');
      const mob = wrap.querySelector('#Shareholders-0-Mobile');
      const how = wrap.querySelector('#Shareholders-0-HowLong');
      const hv = wrap.querySelector('#Shareholders-0-HomeValue');
      const mb = wrap.querySelector('#Shareholders-0-MortgageBalance');
      const yearInc = wrap.querySelector('#Shareholders-0-YearIncorporated');

      if (!valNonEmpty(name, 'Shareholder contact name is required.')) return false;
      if (!valNonEmpty(addr, 'Shareholder address is required.')) return false;

      const telDigits = onlyDigits(tel?.value || '');
      const mobDigits = onlyDigits(mob?.value || '');
      if (!telDigits && !mobDigits) {
        showError(tel || mob, 'Provide at least one phone for shareholder.');
        focusAndScrollTo(tel || mob);
        return false;
      }
      if (!phonesValidSoft()) return false;

      if (!valRadioChecked(wrap, 'shareholders[0][home_status]', 'Select Home Owner or Lessee.')) return false;

      if (!valNonEmpty(how, 'Please enter How Long at current residence.')) return false;

      const homeStatus = wrap.querySelector('input[name="shareholders[0][home_status]"]:checked')?.value || '';
      if (homeStatus === 'Home Owner') {
        if (!valNonEmpty(hv, 'Please enter the Home Value.')) return false;
        if (!valNonEmpty(mb, 'Please enter the Mortgage Balance.')) return false;
      }

      if (!valRadioChecked(wrap, 'shareholders[0][commercial_bankruptcy]', 'Please pick one option.')) return false;

      const shYes = !!wrap.querySelector('input[name="shareholders[0][commercial_bankruptcy]"][value="Yes"]:checked');

      // 2. If Yes, validate the Date Input
      if (shYes && shDoRInput) {
        // A. Check if empty
        if (!valNonEmpty(shDoRInput, 'Please enter the Date of Release.')) {
          return false;
        }

        // B. Check if it is a real calendar date (YYYY-MM-DD)
        if (!isValidDate(shDoRInput.value)) {
          showError(shDoRInput, 'Invalid date. Format must be YYYY-MM-DD.');
          focusAndScrollTo(shDoRInput);
          return false;
        }
      }

      if (!valNonEmpty(yearInc, 'Please enter the Year Incorporated.')) return false;

      let y = parseInt(yearInc.value, 10);
      if (isNaN(y) || y < 1900 || y > CUR_YEAR) {
        showError(yearInc, `Year must be between 1900 and ${CUR_YEAR}.`);
        focusAndScrollTo(yearInc);
        return false;
      }
      return true;
    }

    return true;
  }

  // =========================
  // Progress (entire form)
  // =========================
  const byName = (n) => formEl?.querySelector(`[name="${n}"]`);
  const val = (n) => (byName(n)?.value || '').toString().trim();
  const radio = (n) => !!formEl?.querySelector(`[name="${n}"]:checked`);
  const isEmailOk = () => {
    const el = document.getElementById('LeasingForm-email');
    return el && el.value.trim() !== '' && el.checkValidity();
  };

  function computeProgress() {
    let required = 0, satisfied = 0;

    const step1Checks = [
      () => { required++; if (isEmailOk()) satisfied++; },
      () => { required++; if (val('legal_name_of_business')) satisfied++; },
      () => { required++; if (val('operating_name')) satisfied++; },
      () => { required++; if (val('activity_area')) satisfied++; },
      () => { required++; if (val('address')) satisfied++; },
      () => { required++; if (val('years_in_business')) satisfied++; },
      () => { required++; if (atLeastOnePhoneOk(['LeasingForm-business-phone', 'LeasingForm-mobile-number'])) satisfied++; },
      () => { required++; if (radio('commercial_bankruptcy')) satisfied++; },
      () => { required++; if (radio('legal_actions')) satisfied++; },
    ];
    step1Checks.forEach(fn => fn());

    if (companyDoRInput) {
      const yes = !!formEl.querySelector('input[name="commercial_bankruptcy"][value="Yes"]:checked');
      if (yes) { required++; if (val(companyDoRInput.name || 'Company-DateOfRelease')) satisfied++; }
    }

    const shStarted = Array.from(step2?.querySelectorAll('.shareholder input') || [])
      .some(i => (i.value || '').trim().length);
    if (shStarted) {
      const getRadioVal = (name) => (formEl?.querySelector(`[name="${name}"]:checked`)?.value || '').trim();

      const step2Checks = [
        () => { required++; if (val('shareholders[0][contact_name]')) satisfied++; },
        () => { required++; if (val('shareholders[0][address]')) satisfied++; },
        () => { required++; if (atLeastOnePhoneOk(['Shareholders-0-Phone', 'Shareholders-0-Mobile'])) satisfied++; },
        () => { required++; if (radio('shareholders[0][home_status]')) satisfied++; },
        () => { required++; if (val('shareholders[0][how_long]')) satisfied++; },
        () => { required++; if (radio('shareholders[0][commercial_bankruptcy]')) satisfied++; },
        () => {
          required++; const v = val('shareholders[0][year_incorporated]'); const y = parseInt(v, 10);
          if (!!v && !isNaN(y) && y >= 1900 && y <= CUR_YEAR) satisfied++;
        },
      ];
      step2Checks.forEach(fn => fn());

      if (getRadioVal('shareholders[0][home_status]') === 'Home Owner') {
        required += 2;
        if (val('shareholders[0][home_value]')) satisfied++;
        if (val('shareholders[0][mortgage_balance]')) satisfied++;
      }

      if (getRadioVal('shareholders[0][commercial_bankruptcy]') === 'Yes') {
        required += 1;
        if (val('shareholders[0][date_of_release]')) satisfied++;
      }
    }

    setProgress(required ? (satisfied / required) * 100 : 0);
  }

  // =========================
  // Navigation
  // =========================
  goToStep2?.addEventListener('click', (e) => {
    e.preventDefault();
    if (!validateStep(step1)) return;
    showStep(2);
    scrollAfterReveal(step2);
    computeProgress();
  });
  backToStep1?.addEventListener('click', (e) => {
    e.preventDefault();
    showStep(1);
    scrollAfterReveal(step1);
    computeProgress();
  });

  // =========================
  // Build contact[body] for Shopify
  // =========================
  function buildContactBody() {
    const get = (n) => (formEl?.querySelector(`[name="${n}"]`)?.value || '').toString().trim();
    const getRadio = (name) => (formEl?.querySelector(`[name="${name}"]:checked`)?.value || '').toString().trim();
    const lines = [];

    lines.push('Pre-Approval Application');
    lines.push('========================');
    lines.push('');
    if (urlCtx.sku || urlCtx.product || urlCtx.variant) {
      lines.push('Product Refferal');
      lines.push('--------------');
      if (urlCtx.product) lines.push(`Product: ${urlCtx.product}`);
      if (urlCtx.sku) lines.push(`SKU: ${urlCtx.sku}`);
      if (urlCtx.variant) lines.push(`Variant ID: ${urlCtx.variant}`);
      lines.push('');
    }
    lines.push('Company Info');
    lines.push('------------');
    lines.push(`Email: ${get('contact[email]')}`);
    lines.push(`Legal Name: ${get('legal_name_of_business')}`);
    lines.push(`Operating Name: ${get('operating_name')}`);
    lines.push(`Activity Area: ${get('activity_area')}`);
    lines.push(`Address: ${get('address')}`);
    lines.push(`Business Phone: ${get('business_phone')}`);
    lines.push(`Mobile Number: ${get('mobile_number')}`);
    lines.push(`Years in Business: ${get('years_in_business')}`);
    lines.push(`Commercial Bankruptcy: ${getRadio('commercial_bankruptcy')}`);
    const cdor = document.getElementById('Company-DateOfRelease')?.value || '';
    if (cdor) lines.push(`Date of Release: ${cdor}`);
    lines.push(`Legal Actions: ${getRadio('legal_actions')}`);
    lines.push('');
    lines.push('Shareholders / Partners');
    lines.push('-----------------------');
    lines.push(`Contact Name: ${get('shareholders[0][contact_name]')}`);
    lines.push(`Address: ${get('shareholders[0][address]')}`);
    lines.push(`Telephone: ${get('shareholders[0][telephone]')}`);
    lines.push(`Mobile: ${get('shareholders[0][mobile]')}`);
    lines.push(`Home Status: ${getRadio('shareholders[0][home_status]')}`);
    lines.push(`How Long: ${get('shareholders[0][how_long]')}`);
    lines.push(`Home Value: ${get('shareholders[0][home_value]')}`);
    lines.push(`Mortgage Balance: ${get('shareholders[0][mortgage_balance]')}`);
    lines.push(`Commercial Bankruptcy: ${getRadio('shareholders[0][commercial_bankruptcy]')}`);
    lines.push(`Date of Release: ${get('shareholders[0][date_of_release]')}`);
    lines.push(`Year Incorporated: ${get('shareholders[0][year_incorporated]')}`);
    lines.push('');
    return lines.join('\n');
  }

  // =========================
  // Submit Logic - FINAL, BASED ON WORKING EXAMPLE
  // =========================
  submitBtn?.addEventListener('click', (e) => {
    clearErrors();
    let ok = true;

    if (ok && !validateStep(step1)) { showStep(1); scrollAfterReveal(step1); ok = false; }
    if (ok && !validateStep(step2)) { showStep(2); scrollAfterReveal(step2); ok = false; }
    if (ok && !requireConsent()) ok = false;
    if (ok && !phonesValidSoft()) ok = false;

    if (!ok) {
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation?.();
      return false;
    }

    const bodyEl = document.getElementById('LeasingForm-body');
    if (bodyEl) bodyEl.value = buildContactBody();

    return true;
  });

  formEl?.addEventListener('submit', (e) => {
    if (!validateStep(step1) || !validateStep(step2) || !requireConsent()) {
      e.preventDefault();
      return;
    }
  });

  // =========================
  // Events → progress & toggles
  // =========================
  formEl?.addEventListener('input', (e) => { clearErrors(e.target.closest('section')); computeProgress(); }, { passive: true });
  formEl?.addEventListener('change', (e) => { clearErrors(e.target.closest('section')); computeProgress(); }, { passive: true });

  shareholderHomeStatusRadios?.forEach(radio => radio.addEventListener('change', toggleShareholderHomeFields));
  companyBankruptcyRadios?.forEach(r => r.addEventListener('change', toggleCompanyDoR));
  shBankruptcyRadios?.forEach(r => r.addEventListener('change', toggleShareholderDoR));

  window.addEventListener('resize', () => {
    syncScrollPaddingTop();
    [step1, step2].forEach(s => {
      if (s && !s.classList.contains('is-hidden')) setTitleScrollMargin(s);
    });
  }, { passive: true });

  // =========================
  // Init
  // =========================
  function init() {
    setProgress(0);
    setActiveStep(1);
    syncScrollPaddingTop();
    setTitleScrollMargin(step1);
    wrapAllFieldsForTooltips();
    document.querySelectorAll('.datepicker-input').forEach(wireUpDatepicker);
    document.querySelectorAll('.datepicker-input').forEach(wireUpDateMask);

    // Wire phones
    ['LeasingForm-business-phone', 'LeasingForm-mobile-number', 'Shareholders-0-Phone', 'Shareholders-0-Mobile']
      .forEach(id => wirePhoneInput(document.getElementById(id)));

    // Wire money fields
    wireCurrencyInputById('Shareholders-0-HomeValue');
    wireCurrencyInputById('Shareholders-0-MortgageBalance');

    wireDigitsOnlyById('Shareholders-0-HowLong', { maxDigits: 3 });
    wireDigitsOnlyById('LeasingForm-years-in-business', { maxDigits: 3 });

    const yearInc = document.getElementById('Shareholders-0-YearIncorporated');
    if (yearInc) {
      yearInc.setAttribute('type', 'text');
      yearInc.setAttribute('inputmode', 'numeric');
      yearInc.setAttribute('pattern', '\\d*');
      yearInc.classList.add('no-spinner');
      yearInc.addEventListener('input', () => {
        yearInc.value = (yearInc.value || '').replace(/\D/g, '').slice(0, 4);
        computeProgress();
      });
      yearInc.addEventListener('blur', () => {
        if (!yearInc.value) return;
        let n = parseInt(yearInc.value, 10);
        if (isNaN(n)) { yearInc.value = ''; computeProgress(); return; }
        if (n < 1900) n = 1900;
        if (n > CUR_YEAR) n = CUR_YEAR;
        yearInc.value = String(n);
        computeProgress();
      });
    }

    toggleShareholderHomeFields();
    toggleCompanyDoR();
    toggleShareholderDoR();

    computeProgress();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();